/*
 * Reliable autoplay for optimised product videos (video[data-opt-autoplay]).
 * The theme's deferred-media relies on NATIVE muted autoplay, which mobile / in-app
 * browsers block for below-the-fold videos. This forces play() when the video enters
 * the viewport and pauses it when it leaves. Loaded once as an external asset (never
 * inline inside the deferred-media custom element, which would mangle a <script>).
 */
(function () {
  if (window.__optVideoAutoplay) return;
  window.__optVideoAutoplay = true;

  function play(v) {
    try {
      v.muted = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    } catch (e) {}
  }

  function observe(v) {
    if (v.__optObserved) return;
    v.__optObserved = true;
    if (!('IntersectionObserver' in window)) {
      play(v);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) play(e.target);
        else if (!e.target.paused) e.target.pause();
      });
    }, { threshold: 0.2 });
    io.observe(v);
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('video[data-opt-autoplay]').forEach(observe);
  }

  function init() {
    scan(document);
    if (!('MutationObserver' in window)) return;
    // deferred-media may clone the video into the DOM later; catch those too
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches('video[data-opt-autoplay]')) observe(n);
          else scan(n);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
